import {
  GET_TRANSACTIONS_TYPES_REQUEST,
  GET_TRANSACTIONS_TYPES_SUCCESS,
  GET_TRANSACTIONS_TYPES_FAILURE,
  SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS,
  SAVE_CLIENT_TAX_CODES_MANUAL_FAILURE,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE,
  CLEAR_SAVED_TAX_RATES,
} from '@constants/action-types/transactionTypes';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  transactions: [],
  totalItems: 0,
  registrations: [],
  savedTaxCodes: [],
  error: null,
};

export default reducerFactory(initialState, {
  [CLEAR_SAVED_TAX_RATES]: state => ({ ...state, savedTaxCodeRates: [], error: null }),
  [GET_TRANSACTIONS_TYPES_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [GET_TRANSACTIONS_TYPES_SUCCESS]: (state, { response }) => {
    const { transactions } = response;
    return {
      ...state,
      isLoading: false,
      transactions: [...(transactions && transactions.results)],
      totalItems: transactions.count ? transactions.count : 0,
    };
  },
  [GET_TRANSACTIONS_TYPES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    savedTaxCodes: response,
  }),
  [SAVE_CLIENT_TAX_CODES_MANUAL_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    savedTaxCodeRates: response,
  }),
  [SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
